export default {"src":"/_next/static/media/aysoft_logo_red.4064c71d.svg","height":55,"width":133,"blurWidth":0,"blurHeight":0};